import * as XLSX from 'xlsx';
export const downloadCSV = (data:any[],fileName:string) => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const csv = XLSX.utils.sheet_to_csv(ws);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

export const downloadCSVBlob = (data: any[], fileName: string) => {
  if (!data || data.length === 0) return;

  const header = Object.keys(data[0]).join(",");
  const CHUNK_SIZE = 50000; // 50k rows per flush
  let csvContent = header + "\n";
  const blobParts: BlobPart[] = [];

  for (let i = 0; i < data.length; i++) {
    const row = Object.values(data[i])
      .map(val => (typeof val === "string" ? `"${val.replace(/"/g, '""')}"` : val))
      .join(",");
    csvContent += row + "\n";

    if (i % CHUNK_SIZE === 0 && i !== 0) {
      blobParts.push(csvContent);
      csvContent = "";
    }
  }

  if (csvContent) blobParts.push(csvContent);

  const blob = new Blob(blobParts, { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
};
